import React from 'react';
import { Users, ExternalLink } from 'lucide-react';
import { Button } from '../ui/button';

const MeetupsSection = ({ data }) => {
  const meetups = data?.meetups || [];

  return (
    <section id="meetups" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {data?.section_title || "Join Our Meetup Groups"}
          </h2>
          <div 
            className="text-xl text-gray-600 max-w-2xl mx-auto [&>p]:mb-2 [&>b]:font-semibold [&>strong]:font-semibold [&>i]:italic [&>em]:italic [&>a]:text-gray-600 [&>a]:underline [&>a:hover]:text-gray-400 [&>h1]:text-4xl [&>h1]:font-extrabold [&>h1]:mb-3 [&>h1]:text-gray-900 [&>h2]:text-3xl [&>h2]:font-bold [&>h2]:mb-3 [&>h2]:text-gray-900 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-2 [&>h3]:text-gray-800 [&>h4]:text-xl [&>h4]:font-semibold [&>h4]:mb-2 [&>h4]:text-gray-800 [&>h5]:text-lg [&>h5]:font-medium [&>h5]:mb-2 [&>h5]:text-gray-700 [&>h6]:text-base [&>h6]:font-medium [&>h6]:mb-1 [&>h6]:text-gray-700 [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:mb-2 [&>ol]:list-decimal [&>ol]:ml-6 [&>ol]:mb-2 [&>li]:mb-1"
            dangerouslySetInnerHTML={{ __html: data?.section_description || "Connect with thousands of tech professionals" }}
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {meetups.map((meetup) => (
            <div
              key={meetup.id}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 group border border-gray-200 hover:border-gray-300"
            >
              <div className="flex items-center justify-between mb-6">
                <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Users className="text-gray-900" size={28} />
                </div>
                <span className="text-2xl font-bold text-gray-900">{meetup.members}</span>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{meetup.name}</h3>
              <p className="text-gray-600 leading-relaxed mb-6">{meetup.description}</p>
              <Button
                className="w-full bg-black hover:bg-gray-800 text-white group/btn"
                onClick={() => window.open(meetup.link, '_blank')}
              >
                {meetup.button_text || 'Join Group'}
                <ExternalLink size={16} className="ml-2 group-hover/btn:translate-x-1 transition-transform" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetupsSection;
